(() => {
  const pad = (value) => String(Math.max(0, value)).padStart(2, '0');

  const init = (root) => {
    if (root.dataset.hfReady === 'scroll-v2') return;
    root.dataset.hfReady = 'scroll-v2';
    document.documentElement.classList.add('hf-listicle-page');
    document.body.classList.add('hf-listicle-page');
    document.body.classList.remove('overflow-hidden');
    document.documentElement.style.removeProperty('overflow');
    document.body.style.removeProperty('overflow');
    document.body.style.removeProperty('height');

    const clock = root.querySelector('[data-hf-clock]');
    if (clock) {
      const hours = Math.max(1, Number(root.dataset.countdownHours || 2));
      const windowLength = hours * 60 * 60 * 1000;

      const renderClock = () => {
        // UTC epoch windows make the countdown identical in every timezone.
        const endTime = Math.ceil((Date.now() + 1) / windowLength) * windowLength;
        const remaining = Math.max(0, endTime - Date.now());
        const totalSeconds = Math.floor(remaining / 1000);
        const days = Math.floor(totalSeconds / 86400);
        const hrs = Math.floor((totalSeconds % 86400) / 3600);
        const mins = Math.floor((totalSeconds % 3600) / 60);
        const secs = totalSeconds % 60;

        clock.querySelector('[data-days]').textContent = pad(days);
        clock.querySelector('[data-hours]').textContent = pad(hrs);
        clock.querySelector('[data-minutes]').textContent = pad(mins);
        clock.querySelector('[data-seconds]').textContent = pad(secs);
      };

      renderClock();
      window.setInterval(renderClock, 1000);
    }

    const progress = root.querySelector('[data-hf-progress]');
    const progressAnchor = root.querySelector('[data-hf-progress-anchor]');
    const progressWrapper = root.querySelector('[data-hf-progress-wrapper]');
    const countdown = document.querySelector('[data-esv-countdown].esv-countdown--sticky');
    const sticky = root.querySelector('[data-hf-sticky]');
    const triggerMode = root.dataset.stickyTriggerMode || 'progress';
    const triggerReason = root.dataset.stickyTriggerReason || '4';
    const stickyTrigger = root.querySelector(`[data-reason="${triggerReason}"] .image-wrapper-6`);
    const ctas = root.querySelectorAll('[data-hf-cta]');
    const finalCta = root.querySelector('[data-hf-final-cta]') || ctas[ctas.length - 1] || null;
    const stickyTriggerProgress = Math.min(95, Math.max(0, Number(root.dataset.stickyTriggerProgress || 70)));
    const hideStickyAtFinal = root.dataset.stickyHideAtFinal !== 'false';
    const stickyHideOffset = Math.max(0, Number(root.dataset.stickyHideOffset || 120));
    let ticking = false;

    const scrollPosition = () => {
      const scrollingElement = document.scrollingElement;
      if (scrollingElement) return scrollingElement.scrollTop;
      return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    };
    const documentTop = (element) => element.getBoundingClientRect().top + scrollPosition();
    const pageTop = () => documentTop(root);
    const countdownHeight = () => countdown ? countdown.getBoundingClientRect().height : 0;

    const progressBounds = () => {
      const stackHeight = countdownHeight() + (progressWrapper ? progressWrapper.offsetHeight : 0);
      const start = progressAnchor
        ? documentTop(progressAnchor) - countdownHeight()
        : pageTop();
      const end = finalCta
        ? documentTop(finalCta) - stackHeight
        : pageTop() + root.offsetHeight - window.innerHeight;

      return { start, end: Math.max(start + 1, end) };
    };

    const updateScrollUi = () => {
      const currentScroll = scrollPosition();
      const { start, end } = progressBounds();
      const percent = Math.min(100, Math.max(0, ((currentScroll - start) / (end - start)) * 100));

      if (progress) {
        progress.style.width = 'calc(100% - 6px)';
        progress.style.setProperty('--hf-progress-scale', (percent / 100).toFixed(4));
        progress.setAttribute('aria-valuenow', String(Math.round(percent)));
      }

      if (sticky && root.dataset.stickyEnabled === 'true') {
        const showAt = triggerMode === 'reason' && stickyTrigger
          ? documentTop(stickyTrigger) - window.innerHeight * 0.55
          : start + ((end - start) * stickyTriggerProgress / 100);
        const hideAt = hideStickyAtFinal && finalCta
          ? documentTop(finalCta) - window.innerHeight - stickyHideOffset
          : Number.POSITIVE_INFINITY;
        sticky.classList.toggle('is-visible', currentScroll >= showAt && currentScroll < hideAt);
      }

      ticking = false;
    };

    const requestUpdate = () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(updateScrollUi);
    };

    updateScrollUi();
    window.addEventListener('scroll', requestUpdate, { passive: true });
    document.addEventListener('scroll', requestUpdate, { passive: true, capture: true });
    window.addEventListener('resize', requestUpdate);
    document.addEventListener('esv-countdown:resize', requestUpdate);

    if ('ResizeObserver' in window) {
      const observer = new ResizeObserver(requestUpdate);
      observer.observe(root);
      if (countdown) observer.observe(countdown);
      if (finalCta) observer.observe(finalCta);
    }
  };

  const initAll = () => document.querySelectorAll('[data-hf-listicle]').forEach(init);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();